import React from 'react';
import TableDataField from './TableDataField';

const CodeLocationField = ({ location, borderTop = false }) => {
    let classes = 'col-small text-center';
    if (borderTop) classes += ' border-top';
    return <TableDataField extraStyling={classes}>{location}</TableDataField>;
};

export default CodeLocationField;
